import React, { useCallback, useState, useRef, useEffect } from 'react';
import { Link, useHistory } from "react-router-dom";
import { connect } from "react-redux";
import { Button } from 'devextreme-react/button';
import AccordionReact from 'devextreme-react/accordion';
import FormField from '../../../dynamicFormBuilder/FormField';
import { GridLayout } from "../../../common/GridLayout";
import { createStore } from 'devextreme-aspnet-data-nojquery';
import DataSource from "devextreme/data/data_source";
import Toolbar, { Item } from "devextreme-react/toolbar";
import {
    Column,
    DataGrid,
    GroupPanel,
    Scrolling,
    Grouping,
    FilterRow,
    HeaderFilter,
    FilterPanel,
    Sorting,
    Paging,
    Selection,
    Toolbar as GridToolbar,
    Item as GridToolbarItem,
    Export,
    Pager,
    ColumnChooser,
    ColumnChooserSearch,
    StateStoring,
    Lookup,
} from "devextreme-react/data-grid";
import { buildDxFilters, FillFilters } from '../../../common/Utils';
import { SearchLayout } from './Layout';
import GridLayoutManager from "../../../gridLayoutCustomization/GridLayoutManager";
import axios from 'axios';
import data from '../../../assets/apiRoutes.json';

const searchpanel = [
    {
        ID: 1,
        Title: 'Search Filters'
    }
];

const List = (props) => {
    const history = useHistory();
    var accessToken = props.oidc.user.access_token;
    var currentUser = props.oidc.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    const formRefs = useRef({});
    const [selectedItems, setSelectedItems] = useState([searchpanel[0]]);
    const [searchPanelStatus, setSearchPanelStatus] = useState(false);
    const [isEditButtonDisabled, setIsEditButtonDisabled] = useState(true);
    const rowId = useRef(null);
    const dataGrid = useRef(null);
    const [resultData, setResultData] = useState(null);

    const allowedPageSizes = [10, 20, 100, 500, 1000];
    const gridKey = "800E1767-DDF4-4034-BEC1-4485F9EEEE72";
    const [currentLayout, setCurrentLayout] = useState("Default");
    const loadState = useCallback(() => {
        return GridLayout.sendStorageRequest(gridKey, "GET", accessToken, null, currentLayout);
    }, [currentLayout, accessToken]);

    const saveState = useCallback((state) => {
        GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout);
    }, [gridKey, currentLayout, accessToken]);

    const initialFormFields = {
        TaxCode: null,
        Description1: '',
        Description2: '',
        Status: null,
        Module: 'ID',
        ApplyOnTax1: null,
        RIdFuelAndMiscTaxes: null,
        Comment: null,
        PopupMessage: null,
        ProfileCode: null,
        UserDefinedCode1: null,
        UserDefinedCode2: null,
        UserDefinedCode3: null,
        UserDefinedCode4: null,
        UserDefinedCode5: null,
        UserDefinedCode6: null,
        UserDefinedCode7: null,
        UserDefinedCode8: null,
        UserDefinedCode9: null,
        UserDefinedCode10: null,
        UserDefinedDate1: null,
        UserDefinedDate2: null,
        UserDefinedDate3: null,
        UserDefinedDate4: null,
        UserDefinedDate5: null,
        UserDefinedDate6: null,
        UserDefinedDate7: null,
        UserDefinedDate8: null,
        UserDefinedDate9: null,
        UserDefinedDate10: null,
        UserDefinedQuantity1: null,
        UserDefinedQuantity2: null,
        UserDefinedQuantity3: null,
        UserDefinedQuantity4: null,
        UserDefinedQuantity5: null,
        UserDefinedQuantity6: null,
        UserDefinedQuantity7: null,
        UserDefinedQuantity8: null,
        UserDefinedQuantity9: null,
        UserDefinedQuantity10: null,
        UserDefinedReference1: null,
        UserDefinedReference2: null,
        UserDefinedReference3: null,
        UserDefinedReference4: null,
        UserDefinedReference5: null,
        UserDefinedReference6: null,
        UserDefinedReference7: null,
        UserDefinedReference8: null,
        UserDefinedReference9: null,
        UserDefinedReference10: null,
        UserDefinedComment: null,
        CreationDateTime: null,
        CreationUserId: null,
        LastUpdateDateTime: null,
        LastUpdateUserId: null,
        CompanyId: null,
        KeySequence: null,
    };
    const [formFields, setformFields] = useState(initialFormFields);

    const onSelectionChanged = ({ selectedRowsData }) => {
        if (selectedRowsData && selectedRowsData.length == 1) {
            rowId.current = selectedRowsData[0].RowId;
        }
        else {
            rowId.current = '';
        }
        setIsEditButtonDisabled(!isEditButtonDisabled);
    };

    const handelEditClick = () => {
        const buttonUrl = "/om/codes/sales-tax-code-data-entry-edit?id=" + rowId.current;
        history.push(buttonUrl);
    };

    const selectionChanged = useCallback(
        (e, tg) => {
            let newItems = [...selectedItems];
            e.removedItems.forEach((item) => {
                const index = newItems.indexOf(item);
                if (index >= 0) {
                    newItems.splice(index, 1);
                }
            });
            if (e.addedItems.length) {
                newItems = [...newItems, ...e.addedItems];
            }
            setSelectedItems(newItems);
            setSearchPanelStatus((prevStatus) => {
                const newStatus = !prevStatus;
                return newStatus;
            });
        },
        [selectedItems, setSelectedItems],
    );

    const handleSearch = (e) => {
        e.event.stopPropagation();
        let datasource = loadDatasource();
        const filters = FillFilters(formFields);
        datasource.filter(filters);
        setResultData(datasource);
    };

    const handleReset = (e) => {
        e.event.stopPropagation();
        setformFields(initialFormFields);
        setResultData(loadDatasource());
    };

    useEffect(() => {
        setResultData(loadDatasource());
    }, []);

    const handleFormLoad = useCallback(() => {
        const statusOptions = [
            { id: 'A', text: 'Active' },
            { id: 'I', text: 'Inactive' }
        ];
        const yesNoOptions = [
            { id: 'Y', text: 'Yes' },
            { id: 'N', text: 'No' }
        ];
        setTimeout(() => {
            if (formRefs.current?.["Status"]?.instance) {
                const ref = formRefs.current["Status"];
                ref.instance().option('dataSource', statusOptions);
                ref.instance().option('valueExpr', 'id');
                ref.instance().option('displayExpr', 'text');
            }
            if (formRefs.current?.["ApplyOnTax1"]?.instance) {
                const ref = formRefs.current["ApplyOnTax1"];
                ref.instance().option('dataSource', yesNoOptions);
                ref.instance().option('valueExpr', 'id');
                ref.instance().option('displayExpr', 'text');
            }
        }, 100);
    }, []);

    const handleFieldChange = useCallback((name, value) => {
    }, []);

    const loadDatasource = () => {
        let store = createStore({
            key: 'RowId',
            loadParams: formFields,
            loadUrl: `${window._env_.REACT_APP_APIS}/${data.ID?.GetTaxHeaders || 'id/TaxHeader/GetTaxHeaders'}`,
            onBeforeSend: (method, ajaxOptions) => {
                ajaxOptions.headers = {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                };
            },
        });
        const dataSource = new DataSource({ store: store });
        return dataSource;
    };

    return (
        <div className="search-page-container">
            <div className="search-page-content">
                <div id="accordion" className="search-page-accordion">
                    <AccordionReact
                        dataSource={searchpanel}
                        collapsible={true}
                        multiple={false}
                        animationDuration={300}
                        selectedItems={selectedItems}
                        onSelectionChanged={e => {
                            if (e.currentTarget === e.target) {
                                selectionChanged(e, e.target);
                            }
                        }}
                        itemTitleRender={() => (
                            <Toolbar className="accordian-toolbar">
                                <Item location="before">
                                    <div className="title">
                                        <h6
                                            style={{
                                                color: window._env_.Color2
                                            }}
                                        >
                                            Enter Your Query For ID Sales Tax Codes
                                        </h6>
                                    </div>
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={handleSearch} text="Search" type="default" />
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={handleReset} text="Reset" />
                                </Item>
                            </Toolbar>
                        )}
                        itemRender={(itemProps) => (
                            <FormField
                                currrentUser={currentUser}
                                layoutId='B7D3F1EA-3F7F-4AB5-89F4-1D441F23C8F9'
                                layoutName='OMSalesTaxCodeSearchForm'
                                defaultFormSchema={SearchLayout}
                                formFields={formFields}
                                setformFields={setformFields}
                                handleFieldValueChange={handleFieldChange}
                                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                                formRefs={formRefs}
                                onFormLoad={handleFormLoad}
                                noSpacingBeforeFirstRow={true}
                            />
                        )}
                        id="accordion-container" className="accordion-height"
                    />
                </div>
                <div className="search-page-grid-container">
                    <DataGrid
                        onExporting={(e) => {
                            if (window.handleDevExtremeDataGridExport) {
                                window.handleDevExtremeDataGridExport(e);
                            }
                        }}
                        ref={dataGrid}
                        allowColumnReordering={true}
                        allowColumnResizing={true}
                        dataSource={resultData}
                        showBorders={true}
                        hoverStateEnabled={true}
                        className={selectedItems.length > 0 ? "GridHeightAccordianOpen" : "GridHeightAccordianClose"}
                        onSelectionChanged={(e) => onSelectionChanged(e)}
                        remoteOperations={true}
                        searchEnabled={true}
                        columnAutoWidth={true}
                    >
                        <ColumnChooser
                            enabled={true}
                            title="Choose Column"
                            width={290}
                            height={290}
                            sortOrder="asc"
                        >
                            <ColumnChooserSearch
                                enabled={true}
                                editorOptions={{ placeholder: 'Search column' }} />
                        </ColumnChooser>
                        <Export enabled={true} allowExportSelectedData={true} />
                        <Selection mode="multiple" />
                        <Sorting visible={true} mode="multiple" />
                        <Paging defaultPageSize={10} />
                        <Pager
                            visible={true}
                            showPageSizeSelector={true}
                            allowedPageSizes={allowedPageSizes}
                            showNavigationButtons={true}
                        />
                        <FilterRow visible={true} />
                        <FilterPanel visible={true} />
                        <GroupPanel visible={true} />
                        <Grouping autoExpandAll={false} />
                        <StateStoring
                            enabled={true}
                            type="custom"
                            customLoad={loadState}
                            storageKey={gridKey}
                            customSave={saveState}
                        />
                        <Column dataField="RowId" visible={false} showInColumnChooser={false} />
                        <Column dataType="string" dataField="TaxCode" caption="Tax Code" />
                        <Column dataType="string" dataField="Description1" caption="Description 1" />
                        <Column dataType="string" dataField="Description2" caption="Description 2" />
                        <Column dataType="string" dataField="Status" caption="Status">
                            <Lookup dataSource={[{ id: 'A', text: 'Active' }, { id: 'I', text: 'Inactive' }]} valueExpr="id" displayExpr="text" />
                        </Column>
                        <Column dataType="string" dataField="StateName" caption="State" />
                        <Column dataType="string" dataField="Comment" caption="Comment" allowSorting={false} />
                        <Column dataType="string" dataField="ProfileCode" caption="Profile Code" visible={false} />
                        <Column dataType="string" dataField="ApplyOnTax1" caption="Apply on Tax 1" visible={false}>
                            <Lookup dataSource={[{ id: 'Y', text: 'Yes' }, { id: 'N', text: 'No' }]} valueExpr="id" displayExpr="text" />
                        </Column>
                        <Column dataType="string" dataField="PopupMessage" caption="Popup Message" visible={false} />
                        <Column dataType="string" dataField="KeySequence" caption="Record #"
                            calculateCellValue={(rowData) => {
                                const keySeq = rowData.KeySequence;
                                if (keySeq == null) return '';
                                const alphabet = '0123456789BCDFGHJKLMNPQRSTVWXYZ';
                                let num = keySeq + 2147483647;
                                if (num === 0) return '0';
                                let result = '';
                                while (num > 0) {
                                    result = alphabet[num % 31] + result;
                                    num = Math.floor(num / 31);
                                }
                                return result;
                            }}
                        />
                        <Column dataType="string" dataField="CompanyId" caption="Company" visible={false} />
                        <Column dataType="string" dataField="Module" caption="Module" visible={false} />
                        <Column dataType="string" dataField="RecordType" caption="Record Type" visible={false} />
                        <Column dataType="datetime" dataField="CreationDateTime" caption="Creation Date Time" format="MM/dd/yyyy HH:mm:ss" />
                        <Column dataType="string" dataField="CreationUserId" caption="Creation User" />
                        <Column dataType="datetime" dataField="LastUpdateDateTime" caption="Last Update Date Time" format="MM/dd/yyyy HH:mm:ss" />
                        <Column dataType="string" dataField="LastUpdateUserId" caption="Last Update User" />
                        <Column dataType="string" dataField="UserDefinedCode1" caption="Code 1" visible={false} />
                        <Column dataType="string" dataField="UserDefinedCode2" caption="Code 2" visible={false} />
                        <Column dataType="string" dataField="UserDefinedCode3" caption="Code 3" visible={false} />
                        <Column dataType="string" dataField="UserDefinedCode4" caption="Code 4" visible={false} />
                        <Column dataType="string" dataField="UserDefinedCode5" caption="Code 5" visible={false} />
                        <Column dataType="string" dataField="UserDefinedCode6" caption="Code 6" visible={false} />
                        <Column dataType="string" dataField="UserDefinedCode7" caption="Code 7" visible={false} />
                        <Column dataType="string" dataField="UserDefinedCode8" caption="Code 8" visible={false} />
                        <Column dataType="string" dataField="UserDefinedCode9" caption="Code 9" visible={false} />
                        <Column dataType="string" dataField="UserDefinedCode10" caption="Code 10" visible={false} />
                        <Column dataType="date" dataField="UserDefinedDate1" caption="Date 1" visible={false} />
                        <Column dataType="date" dataField="UserDefinedDate2" caption="Date 2" visible={false} />
                        <Column dataType="date" dataField="UserDefinedDate3" caption="Date 3" visible={false} />
                        <Column dataType="date" dataField="UserDefinedDate4" caption="Date 4" visible={false} />
                        <Column dataType="date" dataField="UserDefinedDate5" caption="Date 5" visible={false} />
                        <Column dataType="date" dataField="UserDefinedDate6" caption="Date 6" visible={false} />
                        <Column dataType="date" dataField="UserDefinedDate7" caption="Date 7" visible={false} />
                        <Column dataType="date" dataField="UserDefinedDate8" caption="Date 8" visible={false} />
                        <Column dataType="date" dataField="UserDefinedDate9" caption="Date 9" visible={false} />
                        <Column dataType="date" dataField="UserDefinedDate10" caption="Date 10" visible={false} />
                        <Column dataType="number" dataField="UserDefinedQuantity1" caption="Quantity 1" visible={false} />
                        <Column dataType="number" dataField="UserDefinedQuantity2" caption="Quantity 2" visible={false} />
                        <Column dataType="number" dataField="UserDefinedQuantity3" caption="Quantity 3" visible={false} />
                        <Column dataType="number" dataField="UserDefinedQuantity4" caption="Quantity 4" visible={false} />
                        <Column dataType="number" dataField="UserDefinedQuantity5" caption="Quantity 5" visible={false} />
                        <Column dataType="number" dataField="UserDefinedQuantity6" caption="Quantity 6" visible={false} />
                        <Column dataType="number" dataField="UserDefinedQuantity7" caption="Quantity 7" visible={false} />
                        <Column dataType="number" dataField="UserDefinedQuantity8" caption="Quantity 8" visible={false} />
                        <Column dataType="number" dataField="UserDefinedQuantity9" caption="Quantity 9" visible={false} />
                        <Column dataType="number" dataField="UserDefinedQuantity10" caption="Quantity 10" visible={false} />
                        <Column dataType="string" dataField="UserDefinedReference1" caption="Reference 1" visible={false} />
                        <Column dataType="string" dataField="UserDefinedReference2" caption="Reference 2" visible={false} />
                        <Column dataType="string" dataField="UserDefinedReference3" caption="Reference 3" visible={false} />
                        <Column dataType="string" dataField="UserDefinedReference4" caption="Reference 4" visible={false} />
                        <Column dataType="string" dataField="UserDefinedReference5" caption="Reference 5" visible={false} />
                        <Column dataType="string" dataField="UserDefinedReference6" caption="Reference 6" visible={false} />
                        <Column dataType="string" dataField="UserDefinedReference7" caption="Reference 7" visible={false} />
                        <Column dataType="string" dataField="UserDefinedReference8" caption="Reference 8" visible={false} />
                        <Column dataType="string" dataField="UserDefinedReference9" caption="Reference 9" visible={false} />
                        <Column dataType="string" dataField="UserDefinedReference10" caption="Reference 10" visible={false} />
                        <Column dataType="string" dataField="UserDefinedComment" caption="User Defined Comment" visible={false} allowSorting={false} />

                        <GridToolbar>
                            <GridToolbarItem location="before">
                                <Button
                                    disabled={isEditButtonDisabled}
                                    onClick={handelEditClick}
                                    type="default"
                                    text="Edit"
                                ></Button>
                            </GridToolbarItem>
                            <GridToolbarItem location="before">
                                <Link to="/om/codes/sales-tax-code-data-entry-create">
                                    <Button
                                        type="default"
                                        text="Create"
                                        className="gridTopButton"
                                    ></Button>
                                </Link>
                            </GridToolbarItem>
                            <GridToolbarItem location="after">
                                <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                            </GridToolbarItem>
                            <GridToolbarItem name="exportButton" />
                            <GridToolbarItem name="columnChooserButton" />
                        </GridToolbar>
                    </DataGrid>
                </div>
            </div>
        </div>
    );
};

function mapStateToProps(state) {
    return {
        oidc: state.oidc
    };
}

export default connect(mapStateToProps)(List);
